import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { initializeAuthThunk } from "./store/slices/authSlice";
import {
  initAnalytics,
  setAnalyticsUser,
  clearAnalyticsUser,
} from "@/utils/gaUtil";

type Props = {
  children: React.ReactNode;
};

export default function AppInitializer({ children }: Props) {
  const dispatch = useAppDispatch();
  const { isInitialized, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    async function initialize() {
      const result = await dispatch(initializeAuthThunk());
      console.log('result' , result)
      setAnalyticsUser(result.payload);
    }
    initialize()
  }, [dispatch]);

  useEffect(() => {
    if (!isInitialized) return;

    if (user) {
    } else {
      clearAnalyticsUser();
    }
  }, [isInitialized, user]);

  if (!isInitialized) {
    return <div>로딩중...</div>;
  }

  return <>{children}</>;
}